"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initHack = initHack;
exports.hackLocalStorage = hackLocalStorage;
exports.hackFetch = hackFetch;
exports.performanceInitializationPromise = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es7.object.values");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var firebase = _interopRequireWildcard(require("firebase/app"));

var _storage = _interopRequireDefault(require("./storage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// @firebase/performance@0.2.26 自身实现有BUG
// 在配置未初始化时（依赖domReady和接口配置接口和本地缓存等，见 initializePerf），所有自定义上报被丢弃（见 logTrace settingsService.loggingEnabled/settingsService.logTraceAfterSampling）
// /node_modules/@firebase/performance/dist/index.cjs.js#738 logTrace()
// 提供自定义的初始化完成（可正常上报事件）状态变化 promise
var IS_INITIALIZATION = false;

var performanceInitializationPromise = function () {
  // 由于其内部未公开API，无法准确判断 performance 初始化完成的时机
  // 根据源码行为（getInitializationPromise）,从 docReady 和 localStorage 写入 两个时机预测是否已初始化完成
  return Promise.resolve().then(function () {
    return getDocumentReadyComplete();
  }).then(function () {
    return new Promise(function (resolve) {
      return setTimeout(resolve, 0);
    });
  }).then(function () {
    return checkStorageConfig();
  }).then(function () {
    return new Promise(function (resolve) {
      return setTimeout(resolve, 1000);
    });
  }) //docReady+storageConfig不能完全保证时序，额外延迟1000ms，极端情况可能延迟后仍未完成
  .then(function () {
    IS_INITIALIZATION = true;
  });
  /**
   * 其内部判断 docReady 的原始方法
   * /node_modules/@firebase/performance/dist/index.cjs.js#578
   *
   * Returns a promise which resolves whenever the document readystate is complete or
   * immediately if it is called after page load complete.
   */

  function getDocumentReadyComplete() {
    if (typeof window === 'undefined') {
      return false;
    }

    var document = window.document;
    return new Promise(function (resolve) {
      if (document && document.readyState !== 'complete') {
        var handler_1 = function handler_1() {
          if (document.readyState === 'complete') {
            document.removeEventListener('readystatechange', handler_1);
            resolve();
          }
        };

        document.addEventListener('readystatechange', handler_1);
      } else {
        resolve();
      }
    });
  }

  function checkStorageConfig() {
    if (typeof window === 'undefined') {
      return false;
    }

    var CONFIG_LOCAL_STORAGE_KEY = '@firebase/performance/config';
    var CONFIG_EXPIRY_LOCAL_STORAGE_KEY = '@firebase/performance/configexpire';
    return new Promise(function (resolve) {
      var intervalHandler;

      var check = function check() {
        if (_storage.default.get({
          key: CONFIG_LOCAL_STORAGE_KEY
        }) && _storage.default.get({
          key: CONFIG_EXPIRY_LOCAL_STORAGE_KEY
        })) {
          if (intervalHandler) {
            clearInterval(intervalHandler);
            intervalHandler = undefined;
          }

          resolve();
        }
      };

      intervalHandler = setInterval(check, 200);
      check();
    });
  }
}(); // hack Track.prototype.record，使其延迟到初始化完成之后再上报
// hack 其它上报方法，增加开发者警告


exports.performanceInitializationPromise = performanceInitializationPromise;

function initHack() {
  // 实质需延迟的是 logTrace，但获取不到引用
  var pref = firebase.performance();
  var trace = pref.trace('unused_initialization_track_needle');
  var prototype = trace.__proto__; // record 方法，fix 成功，不再丢事件

  var ref_record = prototype.record;

  prototype.record = function () {
    var ctx = this;
    var args = arguments; // firebase 对于错误格式的自定义跟踪，将直接丢弃
    // 人为校验字段合法性

    var name = this.name;

    if (!name || name[0] === ' ' || name[name.length - 1] === ' ' || name[0] === '_' || name.length > 32) {
      console.error("[firebase] record() name(".concat(name, ") \u683C\u5F0F\u9519\u8BEF\u3002\u6B63\u786E\u683C\u5F0F\u4E3A\uFF1A\u81EA\u5B9A\u4E49\u5C5E\u6027\u7684\u540D\u79F0\u5FC5\u987B\u6EE1\u8DB3\u4EE5\u4E0B\u8981\u6C42\uFF1A\u6CA1\u6709\u524D\u5BFC\u6216\u5C3E\u968F\u7A7A\u683C\u3001\u6CA1\u6709\u524D\u5BFC\u4E0B\u5212\u7EBF (_) \u5B57\u7B26\uFF0C\u6700\u5927\u957F\u5EA6\u4E3A 32 \u4E2A\u5B57\u7B26"));
    }

    var recordData = args[2];

    if (recordData) {
      if (recordData.attributes) {
        var attrKeys = Object.keys(recordData.attributes);

        if (attrKeys.length > 5) {
          console.error("[firebase] record() \u81EA\u5B9A\u4E49attributes\u6570\u91CF(".concat(attrKeys.length, ")\u4E0D\u80FD\u8D85\u8FC75\u4E2A\uFF0C\u672C\u6761\u6570\u636E\u4E0A\u62A5\u5C06\u5931\u8D25"));
        } else {
          attrKeys.every(function (key) {
            if (!key || key[0] === ' ' || key[key.length - 1] === ' ' || key[0] === '_' || key.length > 32) {
              console.error("[firebase] record() \u81EA\u5B9A\u4E49attribute\u540D\u79F0(".concat(key, ") \u683C\u5F0F\u9519\u8BEF\u3002\u6B63\u786E\u683C\u5F0F\u4E3A\uFF1A\u81EA\u5B9A\u4E49\u5C5E\u6027\u7684\u540D\u79F0\u5FC5\u987B\u6EE1\u8DB3\u4EE5\u4E0B\u8981\u6C42\uFF1A\u6CA1\u6709\u524D\u5BFC\u6216\u5C3E\u968F\u7A7A\u683C\u3001\u6CA1\u6709\u524D\u5BFC\u4E0B\u5212\u7EBF (_) \u5B57\u7B26\uFF0C\u6700\u5927\u957F\u5EA6\u4E3A 32 \u4E2A\u5B57\u7B26"));
            }
          });
          Object.values(recordData.attributes).forEach(function (value) {
            if (typeof value !== 'string') {
              console.error("[firebase] record() \u81EA\u5B9A\u4E49attribute\u503C(".concat(value, ") \u683C\u5F0F\u9519\u8BEF\u3002\u6B63\u786E\u683C\u5F0F\u4E3A\uFF1A\u5B57\u7B26\u4E32"));
            }
          });
        }
      }

      if (recordData.metrics) {
        var metricKeys = Object.keys(recordData.metrics);

        if (metricKeys.length > 32) {
          console.error("[firebase] record() \u81EA\u5B9A\u4E49metrics\u6570\u91CF(".concat(metricKeys.length, ")\u4E0D\u80FD\u8D85\u8FC732\u4E2A\uFF0C\u672C\u6761\u6570\u636E\u4E0A\u62A5\u5C06\u5931\u8D25"));
        } else {
          metricKeys.every(function (key) {
            if (!key || key[0] === ' ' || key[key.length - 1] === ' ' || key[0] === '_' || key.length > 32) {
              console.error("[firebase] record() \u81EA\u5B9A\u4E49metric(".concat(key, ")\u540D\u79F0\u683C\u5F0F\u9519\u8BEF\u3002\u6B63\u786E\u683C\u5F0F\u4E3A\uFF1A\u81EA\u5B9A\u4E49\u6307\u6807\u7684\u540D\u79F0\u5FC5\u987B\u6EE1\u8DB3\u4EE5\u4E0B\u8981\u6C42\uFF1A\u6CA1\u6709\u524D\u5BFC\u6216\u5C3E\u968F\u7A7A\u683C\u3001\u6CA1\u6709\u524D\u5BFC\u4E0B\u5212\u7EBF (_) \u5B57\u7B26\uFF0C\u6700\u5927\u957F\u5EA6\u4E3A 32 \u4E2A\u5B57\u7B26"));
            }
          });
          Object.values(recordData.metrics).forEach(function (value) {
            if (typeof value !== 'number') {
              console.error("[firebase] record() \u81EA\u5B9A\u4E49metric\u503C(".concat(value, ") \u683C\u5F0F\u9519\u8BEF\u3002\u6B63\u786E\u683C\u5F0F\u4E3A\uFF1A\u5B57\u7B26\u4E32\uFF0C").concat(name, ":").concat(JSON.stringify(recordData.metrics)));
            }
          });
        }
      }
    }

    performanceInitializationPromise.then(function () {
      ref_record.apply(ctx, args);
    }).catch(function (e) {
      console.error("[firebase] ".concat(e));
    });
  }; // stop 方法，无法 hack，增加警告


  var ref_stop = prototype.stop;

  prototype.stop = function () {
    if (!IS_INITIALIZATION) {
      console.error('[firebase/performance] 由于其内部实现BUG，此 track.stop() 将丢失自定义跟踪，请改用 track.record()');
    }

    return ref_stop.apply(this, arguments);
  };
}

function hackLocalStorage() {
  if (typeof window === 'undefined') {
    return false;
  } // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
  // throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
  // to avoid the entire page breaking, without having to do a check at each usage of Storage.


  if ((typeof localStorage === "undefined" ? "undefined" : _typeof(localStorage)) === 'object') {
    try {
      var NAME = 'try_localStorage_70930f27';
      localStorage.setItem(NAME, 1);
      localStorage.removeItem(NAME);
    } catch (e) {
      Storage.prototype._setItem = Storage.prototype.setItem;

      Storage.prototype.setItem = function () {};

      console.warn('[firebase]当前不支持storage');
    }
  }
}

function hackFetch() {
  if (typeof window === 'undefined') {
    return false;
  }

  require("whatwg-fetch");
}